import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class MessageService {

    constructor(private http: HttpRequestService) { }

    gets() {
        return this.http.get('messagecontents')
            .map(res => {
                return res.json();
            })
    }
    
    get(marketId, lineBotId) {
        return this.http.get(`messagecontent?market_id=${marketId}&line_bot_id=${lineBotId}`)
            .map(res => {
                return res.json();
            });
    }

    save(model: any) {
        return this.http.put('messagecontent', model).map(res => {
            return res.json();
        });
    }


}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/message.service.ts